
const digest = '701d30d14d99d41075029f9404d9a9b3d4f0d797eeffdbfe54d1fe323c64a317';
const classes = {"wrapper":"_wrapper_1tfth_1"};
const css = `._wrapper_1tfth_1 {
  padding: 24px;
  position: relative;
  background: #ffffff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  